import { customAgentPermissions, qaAgentPermissions } from "./constants";
import type { AgentAction, AgentPermission } from "./types";

/**
 * The permissions authorizing an action on any agent, Standards included: the
 * union over every interaction site, for gates in front of surfaces that serve
 * both kinds (the Agent Console list and details routes).
 */
export const anyAgentPermissionsGetter = (action: AgentAction): AgentPermission[] => {
  return [customAgentPermissions[action], qaAgentPermissions[action]];
};
